import { render, staticRenderFns } from "./RollingNumberText.vue?vue&type=template&id=50b04420&scoped=true"
import script from "./RollingNumberText.vue?vue&type=script&lang=js"
export * from "./RollingNumberText.vue?vue&type=script&lang=js"
import style0 from "./RollingNumberText.vue?vue&type=style&index=0&id=50b04420&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b04420",
  null
  
)

export default component.exports